import { Theme, createMuiTheme } from "@material-ui/core/styles";

import oldTheme from "./theme";

declare module "@material-ui/styles" {
  interface DefaultTheme extends Theme {}
}

declare module "@material-ui/core/styles/createPalette" {
  interface Palette {
    brand: {
      navy: string;
      navyLight: string;
      navyDeep: string;
      navyActive: string;
      coral: string;
      coralHover: string;
      blueAccent: string;
      errorRed: string;
      green: string;
      gray50: string;
      gray100: string;
      gray200: string;
      gray300: string;
      gray400: string;
      gray500: string;
      gray700: string;
      gray900: string;
      white: string;
    };
  }
  interface PaletteOptions {
    brand?: Partial<Palette["brand"]>;
  }
}

const newTheme = createMuiTheme({
  ...oldTheme,
  typography: {
    ...oldTheme.typography,
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
  },
  palette: {
    ...oldTheme.palette,
    brand: {
      navy: "#0F2B4C",
      navyLight: "#1A3A5C",
      navyDeep: "#0A1F38",
      navyActive: "#1E4470",
      coral: "#F06449",
      coralHover: "#E5553A",
      blueAccent: "#2D8CFF",
      errorRed: "#EF4444",
      green: "#10B981",
      gray50: "#F9FAFB",
      gray100: "#F3F4F6",
      gray200: "#E5E7EB",
      gray300: "#D1D5DB",
      gray400: "#9CA3AF",
      gray500: "#6B7280",
      gray700: "#374151",
      gray900: "#111827",
      white: "#FFFFFF",
    },
  },
});

export default newTheme;
